import { Button, Select, Space, Table, Tag, message } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { serverUrl } from "../../../../../nestserver";

const AssignmentList = () => {
  const { Option } = Select;
  const queryClient = useQueryClient();
  const [studentId, setStudentId] = useState(null);

  const authHeaders = () => ({
    Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
  });

  // children of the logged-in parent
  async function fetchParentStudents() {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/students/by-parent/`,
      headers: authHeaders(),
    });
    return res.data.result;
  }
  const students = useQuery("students/by-parent", fetchParentStudents);

  const assignments = useQuery(
    ["assessment/by-student", studentId],
    () =>
      axios({
        method: "get",
        url: `${serverUrl}/exam-v2/by-student?studentId=${studentId}`,
        headers: authHeaders(),
      }).then((res) => res.data),
    { enabled: !!studentId },
  );

  const handleAcknowledge = async (record) => {
    try {
      await axios({
        method: "patch",
        url: `${serverUrl}/exam-v2/marks/${record?._id}/acknowledge`,
        headers: authHeaders(),
      });
      message.success("Acknowledged");
      queryClient.invalidateQueries(["assessment/by-student", studentId]);
    } catch (e) {
      const reason = e?.response?.data?.message;
      message.error(
        (Array.isArray(reason) ? reason[0] : reason) ||
          "Could not acknowledge. Please try again.",
      );
    }
  };

  const columns = [
    {
      title: "Subject",
      key: "subject",
      align: "center",
      render: (record) => (
        <div className="text-base text-center capitalize">
          {record?.exam?.subject?.name || "--"}
        </div>
      ),
    },
    {
      title: "Exam",
      key: "assessment",
      align: "center",
      render: (record) => (
        <div className="text-base text-center capitalize">
          {record?.exam?.name || "--"}
        </div>
      ),
    },
    {
      title: "Marks",
      key: "marks",
      align: "center",
      render: (record) => (
        <div className="text-base text-center font-semibold">
          {record?.marks_obtained ?? 0} / {record?.total_marks ?? 0}
        </div>
      ),
    },
    {
      title: "Remarks",
      key: "remarks",
      align: "center",
      render: (record) => (
        <div className="text-base text-center">{record?.remarks || "--"}</div>
      ),
    },
    {
      title: "Shared On",
      key: "notified_at",
      align: "center",
      render: (record) => (
        <div className="text-base text-center">
          {record?.notified_at
            ? moment(record.notified_at).format("DD MMM YYYY, hh:mm A")
            : "--"}
        </div>
      ),
    },
    {
      title: "Status",
      key: "status",
      align: "center",
      render: (record) =>
        record?.status === "acknowledged" ? (
          <Tag color="green">Acknowledged</Tag>
        ) : (
          <Space size="middle">
            <Tag color="blue">New</Tag>
            <Button size="small" onClick={() => handleAcknowledge(record)}>
              Acknowledge
            </Button>
          </Space>
        ),
    },
  ];

  return (
    <div className="p-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className=" bg-white drop-shadow-md p-8 w-full "
      >
        <div className="text-2xl text-orange-500 font-semibold pb-8">
          Exam Results
        </div>
        <div className="flex gap-4 items-center" style={{ width: "30%" }}>
          <h5 className="text-base font-semibold">Name</h5>
          <Select
            showSearch
            showArrow
            placeholder="Select name"
            className="w-full bg-gray-300"
            style={{ border: "6px", backgroundColor: "#EBEBEB" }}
            getPopupContainer={(trigger) => trigger.parentNode}
            onChange={(value) => setStudentId(value)}
          >
            {students?.data?.map((data) => (
              <Option key={data._id} value={data._id}>
                {`${data?.first_name} ${data?.last_name}`}
              </Option>
            ))}
          </Select>
        </div>
        <div className="py-5">
          <Table
            rowKey="_id"
            loading={assignments.isLoading}
            columns={columns}
            dataSource={
              assignments?.isSuccess && assignments?.data
                ? assignments.data
                : []
            }
            locale={{
              emptyText: studentId
                ? "No marks have been shared yet."
                : "Select a child to see their marks.",
            }}
            pagination={true}
          />
        </div>
      </div>
    </div>
  );
};

export default AssignmentList;
